<template>
  <div>
    <div class="head">
      <div class="top-nav">
        <div class="content">
          <div class="riqi">
            <span id="localtime" v-html="today"></span>
          </div>
          <div class="header-r">
            <div class="search">
              <form
                action="http://www.gxlyzjz.cn/search.jspx"
                target="_blank"
                name="searchForm"
                id="searchForm"
              >
                <input
                  type="text"
                  name="q"
                  value
                  maxlength="50"
                  autocomplete="off"
                  class="searchCon"
                  placeholder="搜索"
                />
                <input type="hidden" name="token" id="token" value />
                <input type="button" value class="searchMenu"  />
              </form>
            </div>
          </div>
          <div class="header_login">
            <ul>
              <li class="login" v-if="this.$root.userName==undefined">
                <router-link to="/login" class="tc">登录</router-link>
              </li>
              <li class="register" v-if="this.$root.userName==undefined">
                <router-link to="/register" class="tc">注册</router-link>
              </li>
              <li class="login on" v-if="this.$root.userName" ><a style="display: inline-block;margin-right: 5px">{{userName}}</a></li>
              <li class="user-child" v-if="this.$root.userName"><a @click="touser()" >会员中心</a></li>
              <li class="user-child" v-if="this.$root.userName"><a  @click="logout" style="display: inline-block;">退出账号</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content">
        <img src="../assets/login_zjz.png" alt class="logo" />
      </div>

      <input value style="display: none" id="userSessionId" />
    </div>
    <div class="content-bg">
      <div class="content" style="background: white">
        <div class="head_banner">
          <div class="banner_top">
            <ul class="commentUl">
              <li :class="this.$root.num==1? 'cols':''">
                <a @click="toIndex()" href="javascript:;" >首页</a>
              </li>
              <li :class="this.$root.num==32? 'cols':''">
                <a @click="toAitrcle(32)" href="javascript:;" >机构简介</a>
              </li>
              <li :class="this.$root.num==37? 'cols':''">
                <a @click="toAitrcle(37)" href="javascript:;" >新闻动态</a>
              </li>
              <li :class="this.$root.num==40? 'cols':''"> 
                <a @click="toAitrcle(40)" href="javascript:;" >通知公告</a>
              </li>
              <li :class="this.$root.num==43? 'cols':''">
                <a @click="toAitrcle(43)" href="javascript:;" >党建专栏</a>
              </li>
              <li :class="this.$root.num==44? 'cols':''">
                <a @click="toAitrcle(44)" href="javascript:;" >资料下载</a>
              </li>
              <li :class="this.$root.num==7? 'cols':''">
                <a  href="http://gxcy.xinghuasuo.com/"  target="_blank">线上检验</a>
              </li>
              <li :class="this.$root.num==45? 'cols':''">
                <a @click="toAitrcle(45)" href="javascript:;" >信息公开</a>
              </li>
              <li :class="this.$root.num==50? 'cols':''">
                <a @click="toAitrcle(50)" href="javascript:;" >综合服务</a>
              </li>
              <li :class="this.$root.num==53? 'cols':''">
                <a @click="toword(53)" href="javascript:;" >互动交流</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      timer: null,
      today: null,
      col:null,
      userName:undefined,
    };
  },
  watch:{
    '$route'(val, from) {
       // 拿到目标参数 val.query.id 去请求接口
        this.userName=localStorage.getItem('userName')
   }
  },
  created(){
      //创建生命周期时候启动定时器
      this.startTimer();
      this.userName=localStorage.getItem('userName')
  },
  methods: {
    touser(){
      this.$router.push({path:'/user',query:{id:1}})
    },
    logout(){
      localStorage.removeItem("userName");
      localStorage.removeItem("id");
      localStorage.removeItem("token");
      this.$root.userName=undefined;
      
    },
    //去首页
    toIndex(){
        this.$root.num=1;
        this.$router.push('/')
    },
    toAitrcle(index){
        this.$root.num=index;
        this.$router.push({path:'/Aitrcle',query:{id:index}})
    },
    toword(index){
      this.$root.num=index;
      this.$router.push({path:'/leaveWord',query:{id:index}})
    },
    toXs(index){
      this.$root.num=index;
    },
    toJgjj(index){
        console.log(index)
        this.$root.num=index;
        this.$router.push({path:'/jgjj',query:{id:32}})
    },
    //启动定时器
    startTimer() {
    
      this.timer = setInterval(() => {
          this.getTime()
      }, 2000);
    },
    //获取当前时间
    getTime() {
      let date = new Date();
      let str, colorhead, colorfoot;
      let yy = date.getYear();
      if (yy < 1900) yy = yy + 1900;
      let MM = date.getMonth() + 1;
      if (MM < 10) MM = "0" + MM;
      let dd = date.getDate();
      if (dd < 10) dd = "0" + dd;
      let hh = date.getHours();
      if (hh < 10) hh = "0" + hh;

      let ww = date.getDay();
      if (ww == 0) colorhead = '<font color="#FF0000">';
      if (ww > 0 && ww < 6) colorhead = '<font color="#373737">';
      if (ww == 6) colorhead = '<font color="#008000">';
      if (ww == 0) ww = "星期日";
      if (ww == 1) ww = "星期一";
      if (ww == 2) ww = "星期二";
      if (ww == 3) ww = "星期三";
      if (ww == 4) ww = "星期四";
      if (ww == 5) ww = "星期五";
      if (ww == 6) ww = "星期六";
      colorfoot = "</font>";
       str =
        colorhead +
        "今天是:   " +
        yy +
        "年" +
        MM +
        "月" +
        dd +
        "日" +
        "    " +
        ww +
        colorfoot;
        console.log(this.str)
      this.today = str;
    }
  }
};
</script>
<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
.cols{
    color:white;
    background: #24a1ff;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue